// extracted by mini-css-extract-plugin
export default {"status":"BTk0d","ok":"viwHK","error":"S8Ql1","inactive":"YbI2L"};